<template>
    <div class="d-flex flex-column align-items-center content mb-0 p24">
        <Icon name="check-green-bg" class="mb24" size="c96" />
        <div class="d-flex flex-column align-items-center">
            <div class="mb24">
                <div class="d-flex justify-content-center align-items-center gap8 mb8">
                    <span v-html="this.summMask(this.internal_amount)"></span>
                    <span class="fsp32 lh40 grey">{{ this.internal_curr_text }}</span>
                </div>
                <span class="neue-roman fsp14 lh20">{{ $t('views.P2P.SingleSwap.56') }}</span>
            </div>
            <div class="w-100 d-flex justify-content-center align-items-center">
                <Button type="btn-success" class="w-100 h48 max-width-btn" @click="this.save()">
                    {{ $t('views.P2P.SingleSwap.57') }}
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon'
import Button from '@/components/service/Button'

export default {
    name: 'NotificationInternalPay',
    components: {
        Icon,
        Button
    },
    data() {
        return {
            internal_amount: this.$store.state.modal.content.internal_amount,
            internal_curr_text: this.$store.state.modal.content.internal_curr_text,
        }
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.isMobile
        }
    },
    methods: {
        summMask(sum) {
            if (!sum) {
                return '';
            }
            let arr = sum.split('.');
            if (arr[1]) {
                return `<span class='text-black neue fw-medium fsp32 lh40'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span><span class='fsp18 primary-grey lh18'>.${arr[1]}</span>`
            } else {
                return `<span class='text-black neue fw-medium fsp32 lh40'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span>`
            }
        },
        save() {
            if (this.$store.state.modal.content.callback) {
                this.$store.state.modal.content.callback();
            }
            this.close();
        },
    }
}
</script>
<style scoped>
.max-width-btn {
    max-width: 192px;
}
</style>

